import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {MatMenuModule} from '@angular/material/menu';
import {MatSelectModule} from '@angular/material/select';
import {MatInputModule} from '@angular/material/input';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatSlideToggleModule} from '@angular/material/slide-toggle';
import {MatButtonModule} from '@angular/material/button';
import {MatIconModule} from '@angular/material/icon';
import {MatRadioModule} from '@angular/material/radio';
import {MatFormFieldModule} from '@angular/material/form-field';
import {MatDialogModule} from '@angular/material/dialog';
import {MatTabsModule} from '@angular/material/tabs';
import {MatSnackBarModule} from '@angular/material/snack-bar';
import {NgxMaskModule} from 'node_modules/ngx-mask';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatSliderModule} from '@angular/material/slider';
import{MatExpansionModule} from '@angular/material/expansion';

@NgModule({
  declarations: [],
  exports:[
    MatMenuModule,
    MatInputModule,
    MatSelectModule,
    MatCheckboxModule,
    MatSlideToggleModule,
    MatButtonModule,
    MatIconModule,
    MatRadioModule,
    MatFormFieldModule,
    MatDialogModule,
    MatFormFieldModule,
    MatTabsModule,
    MatSnackBarModule,
    MatSliderModule,
    MatExpansionModule,

    ReactiveFormsModule,
    NgxMaskModule,
  ],
  imports: [
    CommonModule,
    MatMenuModule,
    MatInputModule,
    MatDialogModule,
    MatFormFieldModule,
    MatButtonModule,
    MatSnackBarModule,
    MatSliderModule,

    NgxMaskModule.forRoot({
      dropSpecialCharacters:true
    }),
    ReactiveFormsModule,
    FormsModule,
    MatIconModule,
  ]
})
export class SharedModule {  }
